import { render } from "./TypesAdmin.vue?vue&type=template&id=254e23a4"
import script from "./TypesAdmin.vue?vue&type=script&lang=js"
export * from "./TypesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__